/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "@fontsource/poppins"
import "@fontsource/roboto"
import "@fontsource/lato"
import "@fontsource/lora"
import "@fontsource/montserrat"
import "@fontsource/oswald"
import "@fontsource/playfair-display"
import "@fontsource/slabo-13px"
import "@fontsource/pt-sans"
import "@fontsource/inconsolata"
import "@fontsource/baloo-2"
import "@fontsource/overlock"
import "@fontsource/sniglet"
import "./src/styles/mixins.scss"
import "./src/styles/animations.scss"
import "./src/styles/buttons.scss"
import { CheckBrowserIsIE } from "./src/components/check-browser-is-IE"

export const onInitialClientRender = () => {
  CheckBrowserIsIE()
  if (navigator.serviceWorker) navigator.serviceWorker.register("./sw.js")
}

export const registerServiceWorker = () => true
